<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Árbontás</span>
    </div>
    <price-breakdown-list/>
  </el-card>
</template>

<script>
import PriceBreakdownList from '../../components/reports/priceBreakdown/List';

export default {
  components: {
    PriceBreakdownList,
  },
};
</script>
